<template>
  <div v-if="userStatus && wizardStep !== 'done'" id="panelChart9" class="panel panel-default">
    <div role="application" class="wizard clearfix" id="steps-uid-0">
      <div class="steps clearfix">
        <ul class="onboarding" role="tablist">
          <li role="tab" class="first" :class="{ disabled: wizardStep !== 'personalInformation', current: wizardStep === 'personalInformation'}" aria-disabled="false" aria-selected="true">
            <a id="steps-uid-0-t-0" aria-controls="steps-uid-0-p-0">
              <span class="current-info audible">current step: </span>
              <span class="number">1.</span> Personal information
              <br>
              <small>Add your personal information</small>
            </a>
          </li>

          <li role="tab" :class="{ disabled: wizardStep !== 'addFundingSource', current: wizardStep === 'addFundingSource'}" aria-disabled="true">
            <a id="steps-uid-0-t-1" aria-controls="steps-uid-0-p-1">
              <span class="number">2.</span> Bank account
              <br>
              <small>Add a bank account</small>
            </a>
          </li>

          <li role="tab" class="last" :class="{ disabled: wizardStep !== 'firstInvestment', current: wizardStep === 'firstInvestment'}" aria-disabled="true">
            <a id="steps-uid-0-t-2" aria-controls="steps-uid-0-p-2"><span class="number">3.</span> Investments
              <br>
              <small>Make your first investment</small>
            </a>
          </li>
        </ul>
      </div><!--steps-->
    </div>
  </div>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'onboardingWizard',
    props: ['userStatus'],
    methods: {
      ...mapActions('home', [
        'getUserStatus',
        'setOnBoardingComplete',
      ]),
    },
    computed: {
      ...mapGetters('app', [
        'hasBeenCreatedAccount',
      ]),
      wizardStep() {
        const { status, needs, onBoardingCompleted } = this.userStatus;
        if (!this.hasBeenCreatedAccount || status === 'retry' || status === 'document') {
          return 'personalInformation';
        }
        if (status === 'verified') {
          if (needs.includes('FUNDING_SOURCE') && !onBoardingCompleted) {
            return 'addFundingSource';
          }
          if (needs.includes('NOTE')) {
            return 'firstInvestment';
          }
          if (!onBoardingCompleted) {
            this.setOnBoardingComplete().then(() => {
              this.getUserStatus({
                accountId: this.activeAccount.id,
              });
            });
          }
        }
        return 'done';
      },
    },
  };
</script>
<style>
</style>



// WEBPACK FOOTER //
// OnboardingWizard.vue?a283a536